/**
 * @flow
 * @relayHash 858f76de275c7722aaeb3322fcc136c4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type emptyState_viewer$ref = any;
export type emptyState_QueryVariables = {|
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
|};
export type emptyState_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: emptyState_viewer$ref,
  |},
|};
*/


/*
query emptyState_Query(
  $license_params: [LicenseUsageParamsInput]
) {
  viewer {
    ...emptyState_viewer
    id
  }
}

fragment emptyState_viewer on Viewer {
  home_page(license_params: $license_params) {
    featured_artist_tracks {
      id
      title
      slug
      price
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
      artist {
        name
        slug
        bio
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        id
      }
      terms {
        edges {
          node {
            id
            is_highlighted
            name
            parent_id
            taxonomy {
              id
              name
            }
          }
        }
      }
    }
    featured_collections {
      id
      description
      name
      slug
      category {
        id
        name
      }
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
    }
    featured_tracks {
      id
      title
      slug
      price
      assets {
        id
        version
        type
        file_format
        path
        metadata
      }
      artist {
        name
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        id
      }
      terms {
        edges {
          node {
            id
            is_highlighted
            name
            parent_id
            taxonomy {
              id
              name
            }
          }
        }
      }
    }
    featured_terms {
      name
      items {
        __typename
        ... on TaxonomyTerm {
          id
          is_highlighted
          name
          parent_id
          taxonomy {
            id
            internal_id
            name
          }
        }
        ... on HomePageLink {
          title
          url
        }
        ... on Node {
          id
        }
      }
    }
    header_posts {
      title
      subtitle
      post_url
      image_url
    }
    blog_posts {
      title
      excerpt
      author
      post_url
      image_url
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_highlighted",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "parent_id",
  "args": null,
  "storageKey": null
},
v9 = [
  v1,
  v6
],
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "terms",
  "storageKey": null,
  "args": null,
  "concreteType": "TaxonomyTermConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [
            v1,
            v7,
            v6,
            v8,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "taxonomy",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": v9
            }
          ]
        }
      ]
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "post_url",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image_url",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "emptyState_Query",
  "id": null,
  "text": "query emptyState_Query(\n  $license_params: [LicenseUsageParamsInput]\n) {\n  viewer {\n    ...emptyState_viewer\n    id\n  }\n}\n\nfragment emptyState_viewer on Viewer {\n  home_page(license_params: $license_params) {\n    featured_artist_tracks {\n      id\n      title\n      slug\n      price\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n      artist {\n        name\n        slug\n        bio\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        id\n      }\n      terms {\n        edges {\n          node {\n            id\n            is_highlighted\n            name\n            parent_id\n            taxonomy {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    featured_collections {\n      id\n      description\n      name\n      slug\n      category {\n        id\n        name\n      }\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n    }\n    featured_tracks {\n      id\n      title\n      slug\n      price\n      assets {\n        id\n        version\n        type\n        file_format\n        path\n        metadata\n      }\n      artist {\n        name\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        id\n      }\n      terms {\n        edges {\n          node {\n            id\n            is_highlighted\n            name\n            parent_id\n            taxonomy {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    featured_terms {\n      name\n      items {\n        __typename\n        ... on TaxonomyTerm {\n          id\n          is_highlighted\n          name\n          parent_id\n          taxonomy {\n            id\n            internal_id\n            name\n          }\n        }\n        ... on HomePageLink {\n          title\n          url\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n    header_posts {\n      title\n      subtitle\n      post_url\n      image_url\n    }\n    blog_posts {\n      title\n      excerpt\n      author\n      post_url\n      image_url\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "emptyState_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "emptyState_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "emptyState_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "home_page",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "license_params",
                "variableName": "license_params",
                "type": "[LicenseUsageParamsInput]"
              }
            ],
            "concreteType": "HomePageContent",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "featured_artist_tracks",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": true,
                "selections": [
                  v1,
                  v2,
                  v3,
                  v4,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "artist",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Artist",
                    "plural": false,
                    "selections": [
                      v6,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "bio",
                        "args": null,
                        "storageKey": null
                      },
                      v5,
                      v1
                    ]
                  },
                  v10
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "featured_collections",
                "storageKey": null,
                "args": null,
                "concreteType": "Collection",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  v6,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionCategory",
                    "plural": false,
                    "selections": v9
                  },
                  v5
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "featured_tracks",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResult",
                "plural": true,
                "selections": [
                  v1,
                  v2,
                  v3,
                  v4,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "artist",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Artist",
                    "plural": false,
                    "selections": [
                      v6,
                      v3,
                      v5,
                      v1
                    ]
                  },
                  v10
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "featured_terms",
                "storageKey": null,
                "args": null,
                "concreteType": "HomePageFeaturedTermsList",
                "plural": true,
                "selections": [
                  v6,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      v1,
                      {
                        "kind": "InlineFragment",
                        "type": "HomePageLink",
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "TaxonomyTerm",
                        "selections": [
                          v7,
                          v6,
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "taxonomy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Taxonomy",
                            "plural": false,
                            "selections": [
                              v1,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "internal_id",
                                "args": null,
                                "storageKey": null
                              },
                              v6
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "header_posts",
                "storageKey": null,
                "args": null,
                "concreteType": "HomePagePost",
                "plural": true,
                "selections": [
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subtitle",
                    "args": null,
                    "storageKey": null
                  },
                  v11,
                  v12
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blog_posts",
                "storageKey": null,
                "args": null,
                "concreteType": "BlogPost",
                "plural": true,
                "selections": [
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "excerpt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "author",
                    "args": null,
                    "storageKey": null
                  },
                  v11,
                  v12
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'f501b96fcdfda14a1f3da558b5e61828';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/emptyState_Query.graphql.js